import type { RotasDoModulo } from '@/app/rotas';

import { DemandsPage } from './DemandsPage';

/** Demandas e SLA. */
export const rotas: RotasDoModulo = {
  menu: { '/demandas': DemandsPage },
};
